import { createButton, createElement } from "./dom";

export class PauseMenu {
  public readonly element = createElement("section", "screen overlay-screen hidden");

  public constructor(
    onResume: () => void,
    onSettings: () => void,
    onControls: () => void,
    onRestart: () => void,
    onQuit: () => void,
  ) {
    this.element.append(
      createElement("div", "eyebrow", "СИМУЛЯЦИЯ ПРИОСТАНОВЛЕНА"),
      createElement("h2", undefined, "ПАУЗА"),
    );
    const actions = createElement("nav", "menu-actions compact");
    actions.append(
      createButton("ПРОДОЛЖИТЬ", onResume),
      createButton("НАСТРОЙКИ", onSettings),
      createButton("УПРАВЛЕНИЕ", onControls),
      createButton("НАЧАТЬ ЗАНОВО", onRestart),
      createButton("ВЕРНУТЬСЯ В МЕНЮ", onQuit),
    );
    this.element.append(actions);
  }

  public show(): void {
    this.element.classList.remove("hidden");
  }

  public hide(): void {
    this.element.classList.add("hidden");
  }
}
